import { createFileRoute, notFound } from "@tanstack/react-router";
import { CraftRenderer } from "@/components/craft/CraftRenderer";
import { loadPageBySlug } from "@/lib/content-loader";
import { isReservedPageSlug } from "@/lib/craft/reserved-slugs";
import { hasCraftContent } from "@/lib/craft/serialize";

export const Route = createFileRoute("/p/$slug")({
  loader: async ({ params }) => {
    if (isReservedPageSlug(params.slug)) throw notFound();
    const page = await loadPageBySlug(params.slug);
    if (!page || !hasCraftContent(page.craftState as string | object)) throw notFound();
    return { page };
  },
  head: ({ loaderData }) => {
    const p = loaderData?.page;
    const title = p?.metaTitle || p?.title || "KS Lau & Co";
    const desc = p?.metaDescription || "";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
      ],
    };
  },
  component: CustomPage,
});

function CustomPage() {
  const { page } = Route.useLoaderData();
  return (
    <CraftRenderer craftState={page.craftState} craftCustomCss={page.craftCustomCss} />
  );
}
